import pkg from '../../package.json';
import type { PackageJson } from './package';

export const packageJson = pkg as PackageJson;
